module.exports = __webpack_public_path__ + "img/conta.a6970d38.png";